import React, { useRef, useContext, useEffect } from 'react';

import { ModalContext } from '$contexts/modal.jsx';
import { useCursorContext } from '$contexts/cursor.jsx';
import { CloseIcon } from '$partials/icon';

import { PropertyAlertFormBlock } from '$partials/modules/blocks';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').AlertModal}
 */
const PropertyAlertModal = (props) => {
    const { handleModal } = useContext(ModalContext);
    const { dispatch: cursorDispatch } = useCursorContext();
    const exitButtonRef = useRef(null);

    useEffect(() => {
        const exit = cursorDispatch({
            type: 'registerArea',
            data: {
                ref: exitButtonRef,
                cursorType: 'exit'
            },
        });

        return () => [exit].map(cleanup => {
            cleanup();});
    }, []);

    return (
        <>
            <div
                className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-hidden bg-black mix-blend-multiply z3 cursor-none'}
                onClick={() => {
                    handleModal();
                }}
                ref={exitButtonRef}
                style={{opacity: '0.2'}}>
            </div>
            <div
                className='height-100 bg-white z5 fixed top-0 overflow-auto modal-container'>
                <button
                    aria-label='Close'
                    className='form-field-reset link-reset absolute right-0 right mt6 mr6 cursor-pointer'
                    onClick={() => {
                        handleModal();
                    }}
                    type='button'>
                    <CloseIcon/>
                </button>
                <PropertyAlertFormBlock
                    handleModal={handleModal}
                    {...props}/>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PropertyAlertModal;
